module.exports = __webpack_public_path__ + "static/media/wdimg1.30d53db8.jpg";